const state = {
    allAgtDet: null,
    allAgentReq: null,
    allAgentRes: null,
    agentDetailsReq: null,
    agentDetailsRes: null,
   
}

// getters
const getters = {
   
    GET_ALL_AGENT_DET: (state) => {
        return state.allAgtDet;
    },
    GET_ALL_AGENT_REQ: (state) => {
        return state.allAgentReq;
    },
    GET_ALL_AGENT_RES: (state) => {
        return state.allAgentRes;
    },
    GET_AGENT_DETAIL_REQ: (state) => {
        return state.agentDetailsReq;
    },
    GET_AGENT_DETAIL_RES: (state) => {
        return state.agentDetailsRes;
    },
}

// actions
const actions = {
    CLEAR_C_AGENT_STORE: ({ commit }) => {
        commit('clearCAgentStore');
    },
    
    SET_ALL_AGENT_DET({ commit }, agents) {
        commit('getAllAgtDet', agents);
    },
    SET_ALL_AGENT_REQ({ commit }, agents) {
        commit('getAllAgentReq', agents);
    },
    SET_ALL_AGENT_RES({ commit }, agentRes) {
        commit('getAllAgentRes', agentRes);
    },
    SET_AGENT_DETAIL_REQ({ commit }, agentDetReq) {
        commit('getAgentDetReq', agentDetReq);
    },
    SET_AGENT_DETAIL_RES({ commit }, agentDetRes) {
        commit('getAgentDetRes', agentDetRes);
    },
}

// mutations
const mutations = {
    clearCAgentStore(state){
        state.allAgtDet = null;
        state.allAgentReq = null;
        state.allAgentRes = null;
        state.agentDetailsReq = null;
        state.agentDetailsRes = null;

    },
    getAllAgtDet(state, agtDet) {
        state.allAgtDet = agtDet
    },
    getAllAgentReq(state, agentReq) {
        state.allAgentReq = agentReq
    },
    getAllAgentRes(state, agentRes) {
        state.allAgentRes = agentRes
    },
    getAgentDetReq(state, agentDetReq) {
        state.agentDetailsReq = agentDetReq
    },
    getAgentDetRes(state, agentDetRes) {
        state.agentDetailsRes = agentDetRes
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};